import createRoute          from '@widesk-ui/tools/createRoute';
import ProductTemplateModel from '@models/shop/ProductTemplateModel';

export default createRoute.splitView('/product_templates', 'shop', 'ProductTemplateSplitView', ProductTemplateModel.localize('plural'));
